import {IPricingUser} from "../../../../../supplier-portal/shared/entities/src/lib/definitions/i-pricing";
import {MessageEventType} from "../enums/message-event-type.enum";

export interface INotificationMessage {
  id: string;
  title: string;
  content: string;
  user: IPricingUser;
  createdAt: Date;
  messageEvents: INotificationMessageEvent[];
  metadata: IMessageMetadata[];
}

export interface INotificationMessageEvent{
  id: string;
  messageEventType: MessageEventType;
  createdAt: Date;
  user: IPricingUser
}

export interface IMessageMetadata{
  id: string;
  key: string;
  value: string;
  locale: string;
}
